const ProductTableHeader = () => {
    return <li className="cart-item header">
        <span className="cart-item-title">
            Product detauls
        </span>
        <span className="cart-item-sprice">
            Unit price
        </span>
        <span className="cart-item-qty">
            Quantity
        </span>
        <span className="cart-item-tprice">
            Total price
        </span>
    </li>
}

export default ProductTableHeader;